(function () {
    "use strict";

    angular.module("app").directive("infiniteScrollIndicator", infiniteScrollIndicatorFactory);
    function infiniteScrollIndicatorFactory() {
        return {
            restrict: "E",
            scope: { datasource: "<", },
            template: `
                <p ng-show="!datasource.isLoading()">
                    {{ 'ScrollForMore' | habilTranslation }} / <strong>{{ 'NumberOfResults' | habilTranslation }}: {{ datasource.ItemCount() }}</strong>
                </p>
                <p ng-show="datasource.isLoading()">
                    <span class="fa fa-solid fa-spinner fa-spin" style="font-size:xx-large;"></span>
                </p>
            `,
            link: function (scope, element) {
                scope.$watch(
                    () => scope.datasource.Ready() && scope.datasource && scope.datasource.IsComplete(),
                    (isComplete) => {
                        element.toggleClass("end-reached", !!isComplete);
                    }
                );
            }
        };
    }
})();